import React, { useContext, useEffect } from "react";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import { reportingEvent } from "../../statics/reportEventId";
import { SessionContext } from "../../context/SessionContext";
import localizationStrings from "../../statics/localization";
import { getColectAgent } from "../../statics/config";
import { ErrorState } from "../status/StatusView";
import { getRecoveryPath, getStatusCopy } from "../status/statusCopy";

const getReportCode = (path, config) => {
  const codes = [
    ["/voddetail", "11006001"],
    ["/profile/", "11010001"],
    ["/profiles", "11010002"],
    ["/selectprofile", "11010003"],
    ["/livetv", "11001007"],
    ["package", "11012001"],
    ["records", "11020001"],
    ["parentalcontrol", "11015001"],
    ["favlockchannel", "11016001"],
    ["purchasehistory", "11013001"],
    ["language", "11014001"],
    ["version", "11019001"],
    ["/search", "11009001"]
  ];
  const match = codes.find(([part]) => path.includes(part));
  if (match) return match[1];
  if (path.includes("/dashboard/home")) {
    const menuId = path.split("/home/")[1]?.split("/")[0];
    const menus = [
      "Special_For_Me_Column",
      "Video_Column",
      "Series_Column",
      "Rent_Buy_Purchase_Column",
      "Child_Column"
    ];
    const index = menus.findIndex(
      (key) => config?.[key] != null && String(config[key]) === menuId
    );
    return `1100400${index < 0 ? 6 : index + 1}`;
  }
  return "11004006";
};

const ErrorFallBack = ({ error, resetErrorBoundary }) => {
  const { userInfo, userFrameConfig } = useContext(SessionContext);
  const history = useHistory();
  const { pathname } = useLocation();
  const copy = getStatusCopy();
  const homeTo = getRecoveryPath();

  useEffect(() => {
    if (!error || userInfo?.usertype !== "1") return;
    // Reporting is best-effort: it must never prevent the recovery screen.
    try {
      const agent = getColectAgent();
      if (!agent || typeof agent.logError !== "function") return;
      const report = agent.logError({
        eventtype: reportingEvent.E_ERROR,
        eventid: reportingEvent.E_ERROR_CRASH,
        sessionid: localStorage.getItem("sessionid"),
        eventtime: moment(
          Date.now() - (Number(localStorage.getItem("timeDiff")) || 0)
        )
          .utc()
          .format("yyyyMMDDHHmmss"),
        errorcode: getReportCode(pathname, userFrameConfig),
        errordesc: localizationStrings.invalidParamError
      });
      if (report && typeof report.catch === "function") report.catch(() => {});
    } catch (reportError) {
      // The original error remains recoverable even if telemetry is unavailable.
    }
  }, [error, pathname, userInfo, userFrameConfig]);

  return (
    <ErrorState
      title={copy.crashTitle}
      description={copy.crashNote}
      onRetry={resetErrorBoundary}
      homeTo={homeTo}
      onHome={() => {
        history.replace(homeTo);
        resetErrorBoundary();
      }}
    />
  );
};

export default ErrorFallBack;
